<ng-container style="display: inline" *ngIf="locked$ | async; else link">
  <img
    style="margin-right: 5px"
    width="24"
    height="24"
    src="/assets/img/icons/cyborg-premium-icon.png"
  />
  <hyperkit-link 
  (click)="openPremiumDialog()"  
  variant="h5" 
  color="primary" 
  [text]="huntPackage.title">
</hyperkit-link>
</ng-container>

<ng-template #link>
  <hyperkit-link 
  [routerLink]="['/research/hunt-package', huntPackage.UUID]"  
  variant="h5" 
  color="primary" 
  [text]="huntPackage.title">
</hyperkit-link>
</ng-template>

